import { getDefaultKeyBinding, KeyBindingUtil } from 'draft-js'

// TODO
// åè®¸èªå®ä¹çå¿«æ·é®è®¾ç½®

export default (customKeyBindingFn) => (event) => {

  if (event.keyCode === 83 && (KeyBindingUtil.hasCommandModifier(event) || KeyBindingUtil.isCtrlKeyCommand(event))) {
    return 'braft-save'
  }

  if (customKeyBindingFn) {
    return customKeyBindingFn(event) || getDefaultKeyBinding(event)
  }

  return getDefaultKeyBinding(event)

}
